import { apiClient } from "@/lib/api/client";

export type RuntimeNetworkDto = {
  preferred_ipv4: string | null;
  ipv4_addresses: string[];
  telemetry_sync_url: string;
};

export async function getRuntimeNetwork(): Promise<RuntimeNetworkDto> {
  const { data } = await apiClient.get<RuntimeNetworkDto>("/runtime/network");
  return data;
}
